export default __webpack_public_path__ + "static/media/groupMsg.d7bfeb01.svg";